<div class="bonus-transfer-type-bottom-sheet">
	<div class="buttons-group">
		<h4 class="buttons-group__title">Выберите способ</h4>
		<div class="buttons-group__items">
			<a
				class="button button--reverse buttons-group__button"
				[routerLink]="[
					'/mobile/payments/payment-own',
					{
						source: productId.toRouteParameter(),
					},
				]"
			>
				На свой счет
			</a>

			<a
				class="button button--reverse buttons-group__button"
				[routerLink]="['/mobile/bonus/change-program', programId]"
			>
				В другую программу лояльности
			</a>
		</div>

		<button
			type="button"
			class="button button--inverted-secondary"
			(click)="close()"
		>
			Отменить
		</button>
	</div>
</div>
